export default __webpack_public_path__ + "car.c8675944.svg";